import { RESET_PASSWORD_COMPLETE, RESET_PASSWORD_ERROR, RESET_PASSWORD_PENDING, RESET_REDUCER } from 'services/AuthService/passwordReset/types';

const INITIAL_STATE = {
  resetPasswordIsCompleted: false,
  resetPasswordIsPending: false,
  resetPasswordIsError: null,
};

const resetPasswordReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case RESET_PASSWORD_COMPLETE:
      return {
        ...state,
        resetPasswordIsCompleted: true,
        resetPasswordIsPending: false,
        resetPasswordIsError: null,
      };
    case RESET_PASSWORD_PENDING:
      return {
        ...state,
        resetPasswordIsCompleted: false,
        resetPasswordIsPending: true,
        resetPasswordIsError: null,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordIsCompleted: false,
        resetPasswordIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        resetPasswordIsError: action.error,
      };

    case RESET_REDUCER:
      return {
        ...state,
        resetPasswordIsCompleted: false,
        resetPasswordIsPending: false,
        resetPasswordIsError: false,
      };

    default:
      return state;
  }
};

export default resetPasswordReducer;
